import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { LoadingService } from '@app/shared/services/loading.service';
import { EMPTY, Observable } from 'rxjs';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.sass'],
})
export class LoaderComponent {
  isLoading$: Observable<boolean> = EMPTY;

  constructor(private readonly _loadingSvc: LoadingService) {
    this.isLoading$ = this._loadingSvc.isLoading$;
  }
}
